<template>
  <BaseDetailLayout title="Company Details">
    <template #action>
      <v-row class="ma-0" justify="end">
        <v-col cols="6" class="pa-0">
          <v-menu
            v-model="datePicker"
            :close-on-content-click="false"
            :nudge-right="0"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <InputField
                :value="dateFilters"
                label="Duration"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                @input="searchModule"
              />
            </template>
            <Calendar
              returnValue="formattedDate"
              v-model="dateFilters"
              :range="true"
            />
          </v-menu>
        </v-col>
      </v-row>
    </template>
    <template #detail>
      <v-row class="ma-0">
        <v-col cols="3" class="pa-0">
          <v-row class="ma-0">
            <v-col cols="12">
              <v-card class="rounded-lg" flat>
                <v-card color="primary" class="rounded-lg" flat>
                  <v-card-text class="pa-0">
                    <v-row class="ma-0">
                      <v-col cols="12" class="pb-0">
                        <v-card flat>
                          <v-row class="ma-0" justify="center">
                            <v-col cols="6" class="pa-0">
                              <v-img
                                alt="brand logo"
                                :src="companyDetails.logo"
                              ></v-img>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                      <v-col cols="12" class="white--text">
                        <span class="text-caption">Company Name</span>
                        <p class="text-subtitle-1 font-weight-bold mb-0">
                          {{ companyDetails.name }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-card-text>
                  <table class="Primary-Table mb-3">
                    <tbody>
                      <tr>
                        <td>Website</td>
                        <td>&nbsp;&nbsp;:&nbsp;&nbsp;</td>
                        <th>{{ companyDetails.website }}</th>
                      </tr>
                      <tr>
                        <td>Contact No</td>
                        <td>&nbsp;&nbsp;:&nbsp;&nbsp;</td>
                        <th>{{ companyDetails.contact_number }}</th>
                      </tr>
                      <tr>
                        <td colspan="3">Address</td>
                      </tr>
                      <tr>
                        <th colspan="3">{{ companyDetails.address }}</th>
                      </tr>
                    </tbody>
                  </table>

                  <PrimaryButton
                    id="subscriptionLogs"
                    name="subscription Logs"
                    @click="getSubscriptionLogs()"
                    btnClass="mr-2 rounded-lg"
                  />
                  <PrimaryButton
                    id="supportTickets"
                    name="Support Tickets"
                    @click="getSupportTickets()"
                  />
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card class="rounded-lg" flat>
                <v-card-title class="py-2">
                  <span class="text-subtitle-1 font-weight-bold">
                    Active Subscription Details
                  </span>
                </v-card-title>
                <v-divider />
                <v-card-text>
                  <table class="Primary-Table">
                    <tbody>
                      <tr>
                        <td>Subscription Name</td>
                        <td>&nbsp;&nbsp;:&nbsp;&nbsp;</td>
                        <th>
                          {{ activeSubscriptionDetails.subscription_name }}
                        </th>
                      </tr>
                      <tr>
                        <td>Duration</td>
                        <td>&nbsp;&nbsp;:&nbsp;&nbsp;</td>
                        <th>
                          {{ activeSubscriptionDetails.start_date }} -
                          {{ activeSubscriptionDetails.end_date }}
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="4" class="pr-2">
              <v-card class="rounded-lg" flat>
                <v-card-text class="pa-2">
                  <span class="text-caption">Orders</span>
                  <p class="mb-0">
                    <v-icon>mdi-archive</v-icon>
                    <span class="text-h6">
                      {{ subscriptionStats?.orders?.order_used }}
                      /
                    </span>
                    <span class="text-subtitle-2">
                      {{ subscriptionStats?.orders?.order_limit }}
                    </span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="px-2">
              <v-card class="rounded-lg" flat>
                <v-card-text class="pa-2">
                  <span class="text-caption">Drivers</span>
                  <p class="mb-0">
                    <v-icon>mdi-account-tie-hat</v-icon>
                    <span class="text-h6">
                      {{ subscriptionStats?.driver?.driver_used }}
                      /
                    </span>
                    <span class="text-subtitle-2">
                      {{ subscriptionStats?.driver?.driver_limit }}
                    </span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="pl-2">
              <v-card class="rounded-lg" flat>
                <v-card-text class="pa-2">
                  <span class="text-caption">Vehicles</span>
                  <p class="text-h6 mb-0">
                    <v-icon>mdi-truck-outline</v-icon>
                    <span class="text-h6">
                      {{ subscriptionStats?.vehicle?.vehicle_used }}
                      /
                    </span>
                    <span class="text-subtitle-2">
                      {{ subscriptionStats?.vehicle?.vehicle_limit }}
                    </span>
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="pr-2">
              <v-card class="rounded-lg" flat>
                <v-card-text class="pa-2">
                  <span class="text-caption">Tickets</span>
                  <p class="text-h6 mb-0">
                    <v-icon>mdi-account-tie</v-icon>
                    {{ companyStatistics.total_tickets }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="px-2">
              <v-card class="rounded-lg" flat>
                <v-card-text class="pa-2">
                  <span class="text-caption">Users</span>
                  <p class="text-h6 mb-0">
                    <v-icon>mdi-account-group</v-icon>
                    {{ companyStatistics.total_users }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="pl-2">
              <v-card class="rounded-lg" flat>
                <v-card-text class="pa-2">
                  <span class="text-caption">Roles</span>
                  <p class="text-h6 mb-0">
                    <v-icon>mdi-card-account-details</v-icon>
                    {{ companyStatistics.total_roles }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="pr-2">
              <v-card class="rounded-lg" flat>
                <v-card-text class="pa-2">
                  <span class="text-caption">Branches</span>
                  <p class="text-h6 mb-0">
                    <v-icon>mdi-source-branch</v-icon>
                    {{ companyStatistics.total_branches }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="px-2">
              <v-card class="rounded-lg" flat>
                <v-card-text class="pa-2">
                  <span class="text-caption">Warehouses</span>
                  <p class="text-h6 mb-0">
                    <v-icon>mdi-warehouse</v-icon>
                    {{ companyStatistics.total_warehouse }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="pl-2">
              <v-card class="rounded-lg" flat>
                <v-card-text class="pa-2">
                  <span class="text-caption">Project</span>
                  <p class="text-h6 mb-0">
                    <v-icon>mdi-alpha-p-box</v-icon>
                    {{ companyStatistics.total_projects }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="9" class="pa-0">
          <v-row class="ma-0">
            <v-col cols="4">
              <v-card color="primary" class="rounded-lg" flat>
                <v-card-title class="white--text py-3">
                  <span class="text-subtitle-1 font-weight-medium">
                    Order Operation Stats
                  </span>
                </v-card-title>
                <v-card class="rounded-lg" flat>
                  <v-card-text class="pa-0">
                    <v-row class="ma-0">
                      <v-col cols="6">
                        <div class="d-flex align-center">
                          <v-icon color="primary" large class="mr-2">
                            mdi-archive
                          </v-icon>
                          <div>
                            <span class="text-caption">Total Orders</span>
                            <p class="mb-0 text-h6 font-weight-bold">
                              {{ orderOperationsStats.total_order }}
                            </p>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <span class="text-caption">Total Adhoc Orders</span>
                        <p class="mb-0 text-subtitle-1 font-weight-bold">
                          <v-icon
                            color="primary"
                            size="18"
                            class="primary rounded-lg pa-1 lighten-5 mr-2"
                            >mdi-archive</v-icon
                          >
                          {{ orderOperationsStats.total_adhoc_orders }}
                        </p>
                      </v-col>
                      <v-col cols="6">
                        <span class="text-caption">Sales Delivery Orders</span>
                        <p class="mb-0 text-subtitle-1 font-weight-bold">
                          <v-icon
                            color="primary"
                            size="18"
                            class="primary rounded-lg pa-1 lighten-5 mr-2"
                            >mdi-archive</v-icon
                          >
                          {{
                            orderOperationsStats.total_sales_delivered_orders
                          }}
                        </p>
                      </v-col>
                      <v-col cols="6">
                        <span class="text-caption">Sales Pickup Orders</span>
                        <p class="mb-0 text-subtitle-1 font-weight-bold">
                          <v-icon
                            color="primary"
                            size="18"
                            class="primary rounded-lg pa-1 lighten-5 mr-2"
                            >mdi-archive</v-icon
                          >
                          {{ orderOperationsStats.total_sales_pickup_orders }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card color="primary" class="rounded-lg" flat>
                <v-card-title class="white--text py-3">
                  <span class="text-subtitle-1 font-weight-medium">
                    Trip Operation Stats
                  </span>
                </v-card-title>
                <v-card class="rounded-lg fill-height" flat>
                  <v-card-text class="pa-0">
                    <v-row class="ma-0">
                      <v-col cols="6">
                        <div class="d-flex align-center">
                          <v-icon color="primary" large class="mr-2">
                            mdi-truck-fast
                          </v-icon>
                          <div>
                            <span class="text-caption">Total Trips</span>
                            <p class="mb-0 text-h6 font-weight-bold">
                              {{ tripOperationsStats.total_trips }}
                            </p>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="6">
                        <span class="text-caption">Planned Trips</span>
                        <p class="mb-0 text-subtitle-1 font-weight-bold">
                          <v-icon
                            color="primary"
                            size="18"
                            class="primary rounded-lg pa-1 lighten-5 mr-2"
                            >mdi-truck-fast</v-icon
                          >
                          {{
                            tripOperationsStats.total_trips_created_thorugh_trip_planning
                          }}
                        </p>
                      </v-col>
                      <v-col cols="6">
                        <span class="text-caption">Total Adhoc Trips</span>
                        <p class="mb-0 text-subtitle-1 font-weight-bold">
                          <v-icon
                            color="primary"
                            size="18"
                            class="primary rounded-lg pa-1 lighten-5 mr-2"
                            >mdi-truck-fast</v-icon
                          >
                          {{ tripOperationsStats.total_adhoc_trips }}
                        </p>
                      </v-col>
                      <v-col cols="6">
                        <span class="text-caption">Total Sales Trips</span>
                        <p class="mb-0 text-subtitle-1 font-weight-bold">
                          <v-icon
                            color="primary"
                            size="18"
                            class="primary rounded-lg pa-1 lighten-5 mr-2"
                            >mdi-truck-fast</v-icon
                          >
                          {{ tripOperationsStats.total_sales_trips }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card color="primary" class="rounded-lg" flat>
                <v-card-title class="white--text py-3">
                  <span class="text-subtitle-1 font-weight-medium">
                    Assets Stats
                  </span>
                </v-card-title>
                <v-card class="rounded-lg" flat>
                  <v-card-text class="pa-0">
                    <v-row class="ma-0">
                      <v-col cols="6">
                        <span class="text-caption">Total Active Drivers</span>
                        <p class="mb-0 text-subtitle-1 font-weight-bold">
                          <v-icon
                            color="primary"
                            size="18"
                            class="primary rounded-lg pa-1 lighten-5 mr-2"
                          >
                            mdi-account-tie-hat
                          </v-icon>
                          {{ assetsStats.total_active_driver }}
                        </p>
                      </v-col>
                      <v-col cols="6">
                        <span class="text-caption">Total Inactive Drivers</span>
                        <p class="mb-0 text-subtitle-1 font-weight-bold">
                          <v-icon
                            color="secondary"
                            size="18"
                            class="secondary rounded-lg pa-1 lighten-5 mr-2"
                          >
                            mdi-account-tie-hat
                          </v-icon>
                          {{ assetsStats.total_deactive_driver }}
                        </p>
                      </v-col>
                      <v-col cols="6">
                        <span class="text-caption">Total Active Vehicles</span>
                        <p class="mb-0 text-subtitle-1 font-weight-bold">
                          <v-icon
                            color="primary"
                            size="18"
                            class="primary rounded-lg pa-1 lighten-5 mr-2"
                            >mdi-truck-outline</v-icon
                          >
                          {{ assetsStats.total_active_vehicle }}
                        </p>
                      </v-col>
                      <v-col cols="6">
                        <span class="text-caption">
                          Total Inactive Vehicles
                        </span>
                        <p class="mb-0 text-subtitle-1 font-weight-bold">
                          <v-icon
                            color="secondary"
                            size="18"
                            class="secondary rounded-lg pa-1 lighten-5 mr-2"
                            >mdi-truck-outline</v-icon
                          >
                          {{ assetsStats.total_deactive_vehicle }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card color="primary" class="rounded-lg" flat>
                <v-card-title class="white--text py-3">
                  <span class="text-subtitle-1 font-weight-medium">
                    Integration Stats
                  </span>
                </v-card-title>
                <v-card class="rounded-lg" flat>
                  <v-card-text class="px-0 pt-2">
                    <v-row class="ma-0">
                      <v-col cols="12">
                        <div class="d-flex">
                          <v-icon color="primary" class="mr-2">
                            mdi-archive
                          </v-icon>
                          <span class="text-subtitle-1">Orders</span>
                          <v-spacer />
                          <span class="text-h6 font-weight-bold">
                            {{ integrationStats.order_created }} /
                            {{ integrationStats.total_order }}
                          </span>
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <div class="d-flex">
                          <v-icon color="primary" class="mr-2">
                            mdi-account
                          </v-icon>
                          <span class="text-subtitle-1">Customers</span>
                          <v-spacer />
                          <span class="text-h6 font-weight-bold">
                            {{ integrationStats.customer_created }} /
                            {{ integrationStats.total_customer }}
                          </span>
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <div class="d-flex">
                          <v-icon color="primary" class="mr-2">
                            mdi-alpha-i-circle
                          </v-icon>
                          <span class="text-subtitle-1">Items</span>
                          <v-spacer />
                          <span class="text-h6 font-weight-bold">
                            {{ integrationStats.item_created }} /
                            {{ integrationStats.total_item }}
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-col>
            <v-col cols="8" class="pa-0">
              <v-row class="ma-0">
                <v-col cols="4">
                  <v-card class="rounded-lg" flat>
                    <v-card-text>
                      <span class="text-caption">Total Consignees</span>
                      <p class="mb-0 text-subtitle-1 font-weight-bold">
                        <v-icon
                          color="primary"
                          size="18"
                          class="primary rounded-lg pa-1 lighten-5 mr-2"
                          >mdi-account-supervisor-circle</v-icon
                        >
                        {{ companyStatistics.total_consignee }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card class="rounded-lg" flat>
                    <v-card-text>
                      <span class="text-caption">Total Customers</span>
                      <p class="mb-0 text-subtitle-1 font-weight-bold">
                        <v-icon
                          color="primary"
                          size="18"
                          class="primary rounded-lg pa-1 lighten-5 mr-2"
                          >mdi-account</v-icon
                        >
                        {{ companyStatistics.total_customer }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card class="rounded-lg" flat>
                    <v-card-text>
                      <span class="text-caption">Total Customer Locations</span>
                      <p class="mb-0 text-subtitle-1 font-weight-bold">
                        <v-icon
                          color="primary"
                          size="18"
                          class="primary rounded-lg pa-1 lighten-5 mr-2"
                          >mdi-map-marker-radius</v-icon
                        >
                        {{ companyStatistics.total_customer_address }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card class="rounded-lg" flat>
                    <v-card-text>
                      <span class="text-caption">Total Items</span>
                      <p class="mb-0 text-subtitle-1 font-weight-bold">
                        <v-icon
                          color="primary"
                          size="18"
                          class="primary rounded-lg pa-1 lighten-5 mr-2"
                          >mdi-alpha-i-circle</v-icon
                        >
                        {{ companyStatistics.total_items }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card class="rounded-lg" flat>
                    <v-card-text>
                      <span class="text-caption">Total Roles</span>
                      <p class="mb-0 text-subtitle-1 font-weight-bold">
                        <v-icon
                          color="primary"
                          size="18"
                          class="primary rounded-lg pa-1 lighten-5 mr-2"
                          >mdi-card-account-details</v-icon
                        >
                        {{ companyStatistics.total_roles }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card class="rounded-lg" flat>
                    <v-card-text>
                      <span class="text-caption">Total Users</span>
                      <p class="mb-0 text-subtitle-1 font-weight-bold">
                        <v-icon
                          color="primary"
                          size="18"
                          class="primary rounded-lg pa-1 lighten-5 mr-2"
                          >mdi-account-group</v-icon
                        >
                        {{ companyStatistics.total_users }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card class="rounded-lg" flat>
                    <v-card-text>
                      <span class="text-caption">Total Zones</span>
                      <p class="mb-0 text-subtitle-1 font-weight-bold">
                        <v-icon
                          color="primary"
                          size="18"
                          class="primary rounded-lg pa-1 lighten-5 mr-2"
                          >mdi-vector-polygon-variant</v-icon
                        >
                        {{ companyStatistics.total_zones }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card class="rounded-lg" flat>
                    <v-card-text>
                      <span class="text-caption">
                        Total Region Restrictions
                      </span>
                      <p class="mb-0 text-subtitle-1 font-weight-bold">
                        <v-icon
                          color="primary"
                          size="18"
                          class="primary rounded-lg pa-1 lighten-5 mr-2"
                          >mdi-alert-octagon</v-icon
                        >
                        {{ companyStatistics.total_region_restrictions }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card class="rounded-lg" flat>
                    <v-card-text>
                      <span class="text-caption">Total Tags</span>
                      <p class="mb-0 text-subtitle-1 font-weight-bold">
                        <v-icon
                          color="primary"
                          size="18"
                          class="primary rounded-lg pa-1 lighten-5 mr-2"
                          >mdi-tag-text</v-icon
                        >
                        {{ companyStatistics.total_tags }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>

    <template #dialog>
      <LogDialog
        v-model="subscriptionLogsDialog"
        :title="`${subscriptionModule.subscription} Logs`"
        :logsArray="subscriptionLogs"
      />
      <BaseDialog
        v-model="supportTicketsDialog"
        :title="`${supportModule.support} ${supportModule.ticket}`"
        width="90%"
      >
        <template #information>
          <CustomTable :headerConfig="itemHeaders" :items="supportTicketList" />
        </template>
      </BaseDialog>
    </template>
  </BaseDetailLayout>
</template>

<script>
import { bus } from "@/main.js";
import BaseDetailLayout from "@/components/LayoutComponents/BaseDetailLayout.vue";
import Calendar from "@/components/ComponentLibrary/datePicker/calendar.vue";
import LogDialog from "@/components/BaseComponents/LogDialog.vue";
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import CustomTable from "@/components/BaseComponents/CustomTable.vue";
import { subscriptionModule, supportModule } from "@/utils/moduleMapping";
export default {
  components: {
    BaseDetailLayout,
    Calendar,
    LogDialog,
    BaseDialog,
    CustomTable,
  },
  data() {
    return {
      subscriptionModule,
      supportModule,
      companyStatistics: {},
      filters: {
        from_date: null,
        to_date: null,
      },
      datePicker: false,
      dateFilters: [],
      subscriptionLogsDialog: false,
      subscriptionLogs: [],
      supportTicketsDialog: false,
      supportTicketList: [],
      itemHeaders: [
        {
          text: "Ticket No",
          value: "ticket_no",
          sortable: false,
        },
        {
          text: "Title",
          value: "title",
          sortable: false,
        },
        {
          text: "Module",
          value: "module",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
        },
        {
          text: "Business Impact",
          value: "impact",
          sortable: false,
        },
        {
          text: "Created",
          value: "created",
          sortable: false,
        },
        {
          text: "Resolution Date",
          value: "resolution_date",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    companyId() {
      return this.$route?.params?.id;
    },
    companyDetails() {
      return this.companyStatistics?.company_details || {};
    },
    activeSubscriptionDetails() {
      return this.companyStatistics?.active_subscription_details || {};
    },
    subscriptionStats() {
      return this.activeSubscriptionDetails?.subscription_stats || {};
    },
    orderOperationsStats() {
      return this.companyStatistics?.order_operations_stats || {};
    },
    tripOperationsStats() {
      return this.companyStatistics?.trip_operations_stats || {};
    },
    assetsStats() {
      return this.companyStatistics?.assets_stats || {};
    },
    integrationStats() {
      return this.companyStatistics?.integration_stats || {};
    },
  },
  watch: {
    dateFilters() {
      if (this.dateFilters.length == 2) {
        this.searchModule();
      }
    },
  },
  methods: {
    searchModule() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        if (this.dateFilters) {
          this.filters.from_date = this.dateFilters[0];
          this.filters.to_date = this.dateFilters[1];
        }
        this.loadData();
      }, 800);
    },
    getCompanyStatistics(params) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.filters,
      };
      this.$api.company
        .getCompanyStatistics(this.companyId, params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.companyStatistics = res.data;
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.error(err);
        });
    },
    getSubscriptionLogs(params) {
      bus.$emit("showLoader", true);
      this.subscriptionLogsDialog = true;
      params = {
        company: this.companyId,
      };
      this.$api.subscription
        .getSubscriptionLogs(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.subscriptionLogs = res.data;
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.error(err);
        });
    },
    getSupportTickets(params) {
      bus.$emit("showLoader", true);
      this.supportTicketsDialog = true;
      params = {
        company: this.companyId,
      };
      this.$api.support
        .getSupportList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.supportTicketList = res.data;
        })
        .catch((res) => {
          bus.$emit("showLoader", false);
          console.error(err);
        });
    },
    loadData() {
      this.getCompanyStatistics();
    },
  },
  mounted() {
    if ("id" in this.$route.params) {
      this.loadData();
    }
  },
};
</script>

<style>
</style>